import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import GridService from '../../components/tribe/tribe_services'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import Event1 from '../../assets/image/event1.jpg'
import Event2 from '../../assets/image/event2.jpg'
import Event3 from '../../assets/image/event3.jpg'

import blended from '../../assets/image/Learning/blended.jpg'
import certification from '../../assets/image/Learning/certification.jpg'
import corporate from '../../assets/image/Learning/corporate.jpg'
import inhouse from '../../assets/image/Learning/inhouse.jpg'
import Learning from '../../assets/image/Learning/Learning.jpg'
let data_services=[
    {
        title:"In-house Workshops",
        content:"Hundreds of organizations have been using our high quality in-class workshops for their training and development needs, with topics ranging from leadership …",
        img:inhouse,
        link:'/services/learning/inhouse'
    },
    {
        title:"Certification Programs",
        content:"Lutan Edukasi Certification and Premium Products are complete sets of workshops to equip your people perform more effectively in your organization. The …",
        img:certification,
        link:'/services/learning/certification'

    },
    {
        title:"Corporate University Services",
        content:"Our Corporate University services provide a complete set of services to support your Corporate University, from planning, preparing, and …",
        img:corporate,
        link:'/services/learning/corporate'

    },
    {
        title:"Blended Learning",
        content:"Training should not be a one-time activity. To ensure its effectiveness, researches have shown that Pre-Training Activities and Post-Training …",
        img:blended,
        link:'/services/learning/blendedlearning'

    },
]
export default class index extends Component {
    render() {
        const image=[
            {image:Learning}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='learning-section'>
                    <Banner bread_crum={['Learning','']} image={image} title="Learning" subtitle="We provide in&#8209;class workshop, public seminars, e&#8209;learning and blended learning solutions in various topics."/>
                    <br/><br/>
                    <div className='learning-content'>
                        <h2>Our Services</h2>
                        <br/><br/>
                        <GridService data={data_services}/>
                        <br/><br/>
                        <div className='success-story'>                        
                            <h2>Our Exclusive Benefits</h2>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{width:1,height:40,backgroundColor:'grey'}}></div>
                            &nbsp;&nbsp;&nbsp;
                            <p>Lutan Edukasi provide exclusive benefits for you and your organization </p>
                        </div>
                        <br/><br/>
                        <div className='list-section'>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>World class programs customized to Indonesian environment</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>Practical skills and tools in each program for daily application</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>Highly interactive adult learning methodology</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   
                                   <p>Comprehensive and cost-effective in-house roll out when required</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>Delivery by high quality professional consultants</p>
                               </div>
                           </div>
                           <br/>
                           <div className='list'>
                               <div className='bullets'>
                                   <div className='list-bullets'></div>
                               </div>
                               <div className='list-content'>
                                   <p>Complete learning and people development solution from pre-assessment, workshops, e-learning, blended learning, follow up tools and evaluations.</p>
                               </div>
                           </div>
                           
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
